import axios from "axios"
import setupInterceptors from "@/services/setup-api-interceptors"

const api = axios.create({
  baseURL: process.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json"
  }
})

export const apiManager = axios.create({
  baseURL: process.env.VITE_API_MANAGER_URL,
  headers: {
    "Content-Type": "application/json"
  }
})

setupInterceptors(api)
setupInterceptors(apiManager)

export default api
